import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import config from '../../../common-sk-doc/src/config';
import { getImageSize, getUrlSkillScreenshot } from '../../../common-sk-doc/src/utils/image';

const ScreenshotOnHover: React.FC<any> = React.forwardRef(({ skill }) => {
    const [opacity, setOpacity] = useState(0);
    const [size, setSize] = useState({ width: 300, height: 200 });

    useEffect(() => {
      setTimeout(() => setOpacity(1), 200);
    }, [skill]);

    useEffect(() => {
      if (skill.skillScreenshots.length > 0) {
        getImageSize(getUrlSkillScreenshot(skill.skillScreenshots[0]), setSize);
      }
    }, [skill]);
    return (
      <div>
        {skill.skillScreenshots.length > 0 ? (
          <div className="screenshot-on-hover" style={{ opacity: opacity }}>
            {skill.skillScreenshots.length === 1 ? (
              <img
                src={getUrlSkillScreenshot(skill.skillScreenshots[0])}
                width={400}
                alt="skill thumbnail"
              />
            ) : (
              <Carousel
                style={{
                  width: size.width,
                  // height: size.height,
                  maxHeight: '50vh',
                  maxWidth: '30vw',
                }}>
                {skill.skillScreenshots.map((ss, i) => {
                  return (
                    <Carousel.Item key={i} interval={1000}>
                      <img
                        src={getUrlSkillScreenshot(ss)}
                        alt="skill thumbnail"
                      />
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            )}
          </div>
        ) : (
          <>
            <div
              className="p-0 screenshot-on-hover"
              style={{ opacity: opacity }}>
              <img
                src={config.ASSETS_PATH + '/images/skill/skill-default.png'}
                alt="skill-preview"
                width={300}
              />
            </div>
          </>
        )}
      </div>
    );
  },
);

export default ScreenshotOnHover;
